<template>
  <div class="w-full xl:w-full flex flex-col space-y-11">
    <div class="flex flex-col">
      <FormLabel class="text-left text-neutral-150 mb-4">{{ $t('landing.do-you-play-sport') }}*</FormLabel>
      <FormRadioGroup
        v-model="goSports"
        :options="radioOptions"
        keyBy="checked"
      />
    </div>
    <div class="flex flex-col">
      <FormLabel class="text-left text-neutral-150 mb-4">
        {{ $t('landing.do-you-lead-a-healthy-lifestyle') }}*
      </FormLabel>

      <FormRadioGroup
        v-model="healthyLifestyle"
        :options="radioOptions"
        keyBy="checked"
      />
    </div>

    <FormTextarea
      v-if="goSports"
      v-model="kindsOfSport"
      :invalid="$v.kindsOfSport.$error"
      :placeholder="placeholders.kindsOfSport[inputState.kindsOfSport]"
      @focus="inputFocusHandler('kindsOfSport')"
      @blur="inputBlurHandler('kindsOfSport')"
    />

    <div>
      <FormFile
        v-show="!resume"
        v-model="resume"
        :accept="[
          'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          'application/vnd.ms-excel',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'application/pdf',
          'application/vnd.oasis.opendocument.text',
          'application/vnd.oasis.opendocument.spreadsheet',
          'image/jpeg',
          'image/png',
          'image/gif',
        ]"
        @input="fileInputHandler"
      />
      <div
        v-if="!!resume"
        class="flex justify-between"
      >
        <div class="flex space-x-2">
          <img src="@/assets/icons/file.svg" alt="" />
          <span>{{resume[0].name}}</span>
        </div>
        <img
          src="@/assets/icons/cancel.svg"
          alt=""
          class="block cursor-pointer"
          @click="resume = null"
        />
      </div>
    </div>

    <div class="flex space-x-2">
      <FormCheckbox
        v-model="agree"
        :invalid="shouldAgreement"
        @input="($event) => shouldAgreement = !$event"
      />
      <p :class="{ 'text-danger-50': shouldAgreement }">
        {{ $t('landing.online-stage-video-recording-agreement') }}
      </p>
    </div>
    <div class="flex sm:flex-col sm:space-y-4 space-x-4 sm:space-x-0">
      <Button palette="neutral-200" @click="goStepBack" class="w-1/2 sm:w-full">
        {{ $t('landing.previous-step') }}
      </Button>

      <Button @click="submitQuestionInfo" class="w-1/2 sm:w-full">{{ $t('landing.send-questionnaire') }}</Button>
    </div>
    <p class="text-center text-neutral-150 text-sm">
      {{ $t('landing.online-stage-personal-link-email') }}
    </p>
  </div>
</template>
<script>
import FormRadioGroup from '@/components/Form/FormRadioGroup.vue';
import FormTextarea from '@/components/Form/FormTextarea.vue';
import FormFile from '@/components/Form/FormFile.vue';
import FormLabel from '@/components/Form/FormLabel.vue';
import FormCheckbox from '@/components/Form/FormCheckbox.vue';
import Button from '@/components/UI/Button.vue';
import sanitize from '@/sanitize';
import toast from '@/notify';

export default {
  name: 'QuestionsInfo',
  components: {
    FormRadioGroup,
    FormTextarea,
    FormFile,
    FormLabel,
    FormCheckbox,
    Button,
  },
  data() {
    return {
      goSports: true,
      healthyLifestyle: true,
      kindsOfSport: '',
      resume: null,
      agree: false,
      shouldAgreement: false,
      radioOptions: [
        { label: this.$t('common.yes'), checked: true },
        { label: this.$t('common.no'), checked: false },
      ],
      inputState: {
        kindsOfSport: 'blur',
      },
      placeholders: {
        kindsOfSport: {
          focus: this.$t('landing.for-example-basketball'),
          blur: this.$t('landing.write-what-sport-do-you-do'),
        },
      },
    };
  },
  mounted() {
    const storageData = JSON.parse(sessionStorage.getItem('questionInfo'));

    if (storageData) {
      this.goSports = storageData.goSports;
      this.kindsOfSport = storageData.kindsOfSport;
      this.resume = storageData.resume;
      this.agree = storageData.agree;
    }
  },
  validations: {
    kindsOfSport: {
      symbolsTest: (value) => !/[\\|/'"`]/g.test(value),
    },
  },
  methods: {
    submitQuestionInfo() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        toast.danger({
          text: this.$t('errors.check-input-correctness'),
        });
        return;
      }
      if (!this.agree) {
        this.shouldAgreement = true;
        return;
      }
      const formData = {
        goSports: this.goSports,
        healthyLifestyle: this.healthyLifestyle,
        kindsOfSport: sanitize(this.kindsOfSport),
        resume: this.resume,
        agree: this.agree,
      };
      // eslint-disable-next-line
      window.ym(91187058, 'reachGoal', 'send_form_candidate');

      this.$emit('question-info-ready', formData);
    },
    goStepBack() {
      this.$emit('go-prev');
    },
    inputFocusHandler(d) {
      this.inputState[d] = 'focus';
    },
    inputBlurHandler(d) {
      this.inputState[d] = 'blur';
    },
    fileInputHandler(e) {
      console.log(e);
    },
  },
};
</script>
